import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setStep } from '..//step/stepSlice';
import { fetchCurrencies } from '../currencies/currenciesSlice';

import { roundNumber } from '../../lib/utils';

import Card from '../../components/Card';
import TransferTypeSelect from '../transferTypes/TransferTypeSelect';
import AmountSelect from './AmountSelect';
import DataPacketSelect from './DataPacketSelect';
import BaseButton from '../../components/BaseButton';
import { steps } from '../step/stepSlice';

export default function SelectAmount() {
  const { selected: selectedTransferType } = useSelector((state) => state.transferTypes);
  const dispatch = useDispatch();

  const handleNext = () => dispatch(setStep(steps.paymentMethods));

  useEffect(() => {
    dispatch(fetchCurrencies());
  }, [dispatch]);

  return (
    <Card step={steps.selectAmount} title="Value for" CollapsedContent={CollapsedContent}>
      <div className="select-amount">
        <TransferTypeSelect />
        <AmountSelect />
        {selectedTransferType === 2 && <DataPacketSelect />}
        <BaseButton onClick={handleNext}>Next</BaseButton>
      </div>
    </Card>
  );
}

function CollapsedContent() {
  const { currencies, product } = useSelector((state) => state);
  const { selected: selectedNetwork } = useSelector((state) => state.networks);
  const { selected } = useSelector((state) => state.transferTypes);

  const recipientAmountString = `${roundNumber(currencies.receiver.rate * product.amount, 2)} ${
    currencies.receiver.name
  }`;

  const senderAmountString = `${roundNumber(currencies.sender.rate * product.amount, 2)} ${
    currencies.sender.name
  }`;

  const getDataName = () => {
    const sku = product.sku;

    const dp = selectedNetwork.dataPackets.find((f) => f.amount === product.amount);

    if (!dp) {
      return '';
    }

    const selectedDp = dp.packets.find((d) => d.sku === sku);

    return selectedDp ? selectedDp.name : '';
  };

  const getDescription = () => {
    switch (selected) {
      case 1:
        return recipientAmountString;
      case 2:
        return getDataName();
      default:
        throw new Error('unknown transferType');
    }
  };
  return (
    <div className="collapsed-content">
      <div className="content selected-value">
        <div className="amount">{senderAmountString}</div>
        <div className="description">Receiver gets {getDescription()}</div>
      </div>
    </div>
  );
}
